import {CopilotDropzone, EventType} from './copilot.enums';
import {CopilotContainerSettings, CopilotSettings} from './copilot.types';
import {RouterPromptFormat} from './routing/routing.enums';

export const copilotContainerSettingsDefaults: CopilotContainerSettings = {
  x: 0,
  y: 0,
  width: 375,
  height: 450,
  dropzone: CopilotDropzone.None,
  activeDropzone: CopilotDropzone.None,
};

export const copilotSettingsDefaults: CopilotSettings = {
  fontSize: 14,
  playbackRate: 1,
  isVoiceEnabled: false,
  isEditArticlesEnabled: false,
  promptToImageModel: 9, // open AI gpt-image-1
  promptToImageWithReferenceImagesModel: 11, // open AI gpt-image-1
  hiddenChatItemTypes: [],
  routerPromptFormat: RouterPromptFormat.ActionResult,
};

export const copilotPlaybackRates = [0.75, 1, 1.25, 1.5, 2];
export const copilotFontSizes = [10, 12, 14, 16, 18];

export const startedEventTypeToEndedEventType: Partial<Record<EventType, EventType>> = {
  [EventType.ToolCallStarted]: EventType.ToolCallEnded,
  [EventType.RoutingStarted]: EventType.RoutingEnded,
  [EventType.AgentSessionSummaryStarted]: EventType.AgentSessionSummaryEnded,
  [EventType.AskStarted]: EventType.AskEnded,
  [EventType.RequestUserFeedbackStarted]: EventType.RequestUserFeedbackEnded,
  [EventType.CancellationStarted]: EventType.CancellationEnded,
  [EventType.UploadAndAnalyzeDraftFilesStarted]: EventType.UploadAndAnalyzeDraftFilesEnded,
  [EventType.StandaloneLLMCallStarted]: EventType.StandaloneLLMCallEnded,
  [EventType.InvokeAgentStarted]: EventType.InvokeAgentEnded,
  [EventType.ClassificationStarted]: EventType.ClassificationEnded,
  [EventType.HandoffStarted]: EventType.HandoffEnded,
};
